module.exports = __webpack_public_path__ + "img/win_icon.141d5f51.svg";